// src/v3/ui/_common/hooks/use-toast.ts

import { useCallback, useState } from "react";
import {
  createToast,
  type ToastData,
  type ToastVariant,
} from "../components/ui/toast";

export function useToast() {
  const [toasts, setToasts] = useState<ToastData[]>([]);

  const dismissToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const showToast = useCallback(
    (variant: ToastVariant, message: string, retryAction?: () => void) => {
      const toast = createToast(variant, message, retryAction);
      setToasts((prev) => [...prev, toast]);
      return toast.id;
    },
    [],
  );

  const dismissAll = useCallback(() => {
    setToasts([]);
  }, []);

  return {
    toasts,
    dismissToast,
    dismissAll,
    showToast,
  };
}
